import React from 'react';
import Rad_PI_Logo from './Assets/Rad_PI_Logo.png';
import Ortho from './Assets/OrthoBrochure.png';
import Spine from './Assets/BackBrochure.png';
import Plastic from './Assets/PlasticBrochure.png';
import Hip from './Assets/HipBrochure.png';
import '../App.css';

const AboutUs = () => {
  return (
    <div className="about-page">
      <div className="about-crescent">
      <svg
        viewBox="0 0 241.88922 576"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Decorative half circle shape"
      >
        <path d="m128.60921 0c-5.95449 8.91665-11.61559 18.01208-16.84771 27.37516-6.36639 11.39289-12.06065 23.10846-17.17417 35.11448-7.88554 18.51437-14.16695 37.56114-18.96088 57.09579-3.18487 12.97787-5.65012 26.09759-7.50658 39.33595-1.18832 8.47377-1.91138 16.99226-2.72536 25.50246-.30412 3.17961-.3893 6.38039-.56424 9.57207-.49476 9.02652-.67521 18.06386-.43738 27.09662.22917 8.7037.57994 17.40405 1.2724 26.09302.80054 10.04521 1.95221 20.041 3.38424 30.01161 1.60397 11.16769 3.71006 22.24002 6.16592 33.24832 3.57408 16.02075 8.09169 31.77829 13.41437 47.2995 5.24427 15.29257 11.29015 30.26535 18.09399 44.93906 11.36773 24.51657 24.746 47.87924 40.04411 70.14124 8.88202 12.92523 18.38478 25.38531 28.51964 37.36206 6.92215 8.18011 14.13173 16.09149 21.43832 23.93103 6.66339 7.14941 13.73906 13.85956 20.84544 20.53412 7.45583 7.00287 15.19977 13.70087 23.11728 20.18817.42888.3515.8017.77136 1.20062 1.15936-80.61957 0-161.23914 0-241.88936 0 0-192 0-384 .00102-576 42.87013-.00002 85.73923-.00002 128.60833-.00002z" />
      </svg>
      </div>
      <div className="about-container">
        <h1 className="about-title">About Us</h1>
        <img src={Rad_PI_Logo} className="about-logo" alt="Radiance PI" />

        <div className="specialties-container">
          <div className="specialty-section">
            <img src={Spine} alt="Spine Icon" />
            <span className="spine">Spine</span>
            <ul>
              <li>Trauma</li>
              <li>Injuries</li>
              <li>Deformity</li>
            </ul>
          </div>
          <div className="specialty-section">
            <img src={Hip} alt="Hip Icon" />
            <span className="hip">Pain Management</span>
            <ul>
              <li>Epidural Injections</li>
              <li>PRP Joint Injections</li>
              <li>Pain Stimulators</li>
            </ul>
          </div>
          <div className="specialty-section">
            <img src={Ortho} alt="Ortho Icon" />
            <span className="ortho">Orthopedic</span>
            <ul>
              <li>Shoulder</li>
              <li>Hip & Knee</li>
              <li>Hand & Foot</li>
            </ul>
          </div>
          <div className="specialty-section">
            <img src={Plastic} alt="Plastic Surgery Icon" />
            <span className="plastic">Plastic Surgery</span>
            <ul>
              <li>Facial/Nose Trauma</li>
              <li>Scar Revisions/Burns</li>
              <li>Reconstructive Surgery</li>
            </ul>
          </div>
        </div>

        <div className="locations">
          <h2>Specialist Locations</h2>
          <div className="locations-list-container">
            <ul className="locations-list">
              <li>Bakersfield</li>
              <li>Beverly Hills</li>
              <li>Brentwood</li>
              <li>Burbank</li>
              <li>Century City</li>
              <li>Costa Mesa</li>
              <li>Downey</li>
              <li>El Monte</li>
              <li>Encino</li>
              <li>Glendale</li>
              <li>Lancaster</li>
              <li>Long Beach</li>
              <li>Los Angeles</li>
              <li>Marina Del Rey</li>
              <li>Mission Hills</li>
              <li>Moorpark</li>
              <li>Newbury Park</li>
              <li>Newport Beach</li>
              <li>Northridge</li>
              <li>Oxnard</li>
              <li>Palmdale</li>
              <li>Porter Ranch</li>
              <li>Rancho Cucamonga</li>
              <li>San Pedro</li>
              <li>Santa Monica</li>
              <li>Sherman Oaks</li>
              <li>Simi Valley</li>
              <li>Thousand Oaks</li>
              <li>Toluca Lake</li>
              <li>Valencia</li>
              <li>Van Nuys</li>
              <li>West Covina</li>
              <li>Woodland Hills</li>
            </ul>          
          </div>
        </div>
        <div className="Info">
        <a href="mailto:info@radiance-pi.com">Questions: Info@Radiance-PI.com</a>
        </div>
      </div>
    </div>
    
  );
}

export default AboutUs;